// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RhUY7FhTJfW1frEFBqGk {
  border-bottom: 1px solid #ddd;
  padding-top: 5px;
  padding-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Components/index.module.less"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,gBAAA;EACA,mBAAA;AACF","sourcesContent":[".header {\n  border-bottom: 1px solid #ddd;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `RhUY7FhTJfW1frEFBqGk`
};
export default ___CSS_LOADER_EXPORT___;
